import { render, staticRenderFns } from "./viewDraw.vue?vue&type=template&id=120a3f86&scoped=true&"
import script from "./viewDraw.vue?vue&type=script&lang=js&"
export * from "./viewDraw.vue?vue&type=script&lang=js&"
import style0 from "./viewDraw.vue?vue&type=style&index=0&id=120a3f86&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120a3f86",
  null
  
)

export default component.exports